import { memo, useEffect } from "react";
import { useLoaderData, useLocation, useOutlet } from "react-router-dom";
import { useAuth } from "../hooks";

export const ProtectedRoute = memo(() => {
  const outlet = useOutlet();
  const location = useLocation();
  const { logout } = useAuth();
  const { token } = useLoaderData() as { token?: string };

  useEffect(() => {
    if (!token) {
      logout({ replace: true, state: { from: location } });
    }
  }, [location, logout, token]);

  return outlet;
});
